import request from "@/utils/request"

//税款确认信息
export function taxConfirmInfo(data) {
  return request({
    url: "api/v2/qywx/tax/taxConfirm",
    method: "post",
    data,
  })
}

//税款确认

export function taxConfirm(data) {
  return request({
    url: "api/v2/qywx/tax/taxConfirm/confirm",
    method: "post",
    data,
  })
}

//社保确认
export function sbConfirm(data) {
  return request({
    url: "api/v2/qywx/tax/taxConfirm/sbConfirm",
    method: "post",
    data,
  })
}

//税款预估信息
export function taxEstimationInfo(data) {
  return request({
    url: "api/v2/qywx/tax/taxEstimation",
    method: "post",
    data,
  })
}

//税款预估发票明细下载
export function taxEstimationExport(data) {
  return request({
    url: "api/v2/qywx/tax/taxEstimation/invoiceExport",
    method: "post",
    data,
  })
}

//复制税款预估
export function copyTaxEstimate(data) {
  return request({
    url: "api/v2/company/copyTaxEstimate",
    method: "post",
    data,
  });
}

// 社保确认群发的文件
export function shebaoDetail(data) {
  return request({
    url: "api/v2/export/shebaoDetail",
    method: "post",
    data,
  });
}


// 基础版税款确认
export function baseTaxConfirm(data) {
  return request({
    url: "api/v2/qywx/tax/baseTaxConfirm",
    method: "post",
    data,
  });
}

// 企业所得税预估
export function copyTaxQyEstimate(data) {
  return request({
    url: "api/v2/company/copyQysdsEstimate",
    method: "post",
    data,
  });
}

